export default {
  "0" : {
    "scenarioValuesAllRegions": [
      {
        "regionId": "0",
        "year": 1970,
        "scenarioValue": 0.03
      },
      {
        "regionId": "0",
        "year": 2000,
        "scenarioValue": 0.42
      },
      {
        "regionId": "0",
        "year": 2010,
        "scenarioValue": 0.72
      },
      {
        "regionId": "0",
        "year": 2020,
        "scenarioValue": 0.910367398145204
      },
      {
        "regionId": "0",
        "year": 2030,
        "scenarioValue": 1.12729480256727
      },
      {
        "regionId": "0",
        "year": 2040,
        "scenarioValue": 1.36372702358494
      },
      {
        "regionId": "0",
        "year": 2050,
        "scenarioValue": 1.61445961332678
      },
      {
        "regionId": "0",
        "year": 2060,
        "scenarioValue": 1.88265754784888
      },
      {
        "regionId": "0",
        "year": 2070,
        "scenarioValue": 2.1678093704226
      },
      {
        "regionId": "0",
        "year": 2080,
        "scenarioValue": 2.46533843817285
      },
      {
        "regionId": "0",
        "year": 2090,
        "scenarioValue": 2.77429173161172
      },
      {
        "regionId": "0",
        "year": 2100,
        "scenarioValue": 3.0942542764845
      }
    ],
    "factor": {
      "id": "0",
      "unit": "Celcius",
      "unitShort": "C",
      "title": "Temperature Increase (world)"
    }
  },
  "1" : {
    "scenarioValuesAllRegions": [
      {
        "regionId": "0",
        "year": 2012,
        "scenarioValue": 1.57727345041317
      },
      {
        "regionId": "0",
        "year": 2020,
        "scenarioValue": 1.59975832863899
      },
      {
        "regionId": "0",
        "year": 2030,
        "scenarioValue": 1.75764279986427
      },
      {
        "regionId": "0",
        "year": 2040,
        "scenarioValue": 1.8762155637162
      },
      {
        "regionId": "0",
        "year": 2050,
        "scenarioValue": 1.97728401872962
      },
      {
        "regionId": "0",
        "year": 2060,
        "scenarioValue": 2.11476456228175
      },
      {
        "regionId": "0",
        "year": 2070,
        "scenarioValue": 2.2077035295042
      },
      {
        "regionId": "0",
        "year": 2080,
        "scenarioValue": 2.25913976058358
      },
      {
        "regionId": "0",
        "year": 2090,
        "scenarioValue": 2.31344553393039
      },
      {
        "regionId": "0",
        "year": 2100,
        "scenarioValue": 2.34805553090881
      }
    ],
    "factor": {
      "id": "1",
      "unit": "Number of earths",
      "unitShort": "earths",
      "title": "Required Earths (world)"
    }
  },
  "4" : {
    "scenarioValuesAllRegions": [
      {
        "regionId": "0",
        "year": 2000,
        "scenarioValue": 8187.0376918396
      },
      {
        "regionId": "0",
        "year": 2010,
        "scenarioValue": 9543.09201928396
      },
      {
        "regionId": "0",
        "year": 2020,
        "scenarioValue": 11051.7398613888
      },
      {
        "regionId": "0",
        "year": 2030,
        "scenarioValue": 13898.201276544
      },
      {
        "regionId": "0",
        "year": 2040,
        "scenarioValue": 16315.6168310072
      },
      {
        "regionId": "0",
        "year": 2050,
        "scenarioValue": 18523.4116574612
      },
      {
        "regionId": "0",
        "year": 2060,
        "scenarioValue": 20843.0808918034
      },
      {
        "regionId": "0",
        "year": 2070,
        "scenarioValue": 23353.439696327
      },
      {
        "regionId": "0",
        "year": 2080,
        "scenarioValue": 26090.8261997617
      },
      {
        "regionId": "0",
        "year": 2090,
        "scenarioValue": 29142.2757527341
      },
      {
        "regionId": "0",
        "year": 2100,
        "scenarioValue": 32488.2979092718
      }
    ],
    "factor": {
      "id": "4",
      "unit": "2010$GDP/capita",
      "unitShort": "2010$/cap",
      "title": "Affluence"
    }
  },
  "6" : {
    "scenarioValuesAllRegions": [
      {
        "regionId": "0",
        "year": 2000,
        "scenarioValue": 0.480583664527278
      },
      {
        "regionId": "0",
        "year": 2010,
        "scenarioValue": 0.486011802621078
      },
      {
        "regionId": "0",
        "year": 2020,
        "scenarioValue": 0.407592251380732
      },
      {
        "regionId": "0",
        "year": 2030,
        "scenarioValue": 0.333307995042814
      },
      {
        "regionId": "0",
        "year": 2040,
        "scenarioValue": 0.286981837937811
      },
      {
        "regionId": "0",
        "year": 2050,
        "scenarioValue": 0.257756795433846
      },
      {
        "regionId": "0",
        "year": 2060,
        "scenarioValue": 0.245886419939636
      },
      {
        "regionId": "0",
        "year": 2070,
        "scenarioValue": 0.2319475790011
      },
      {
        "regionId": "0",
        "year": 2080,
        "scenarioValue": 0.216948301474522
      },
      {
        "regionId": "0",
        "year": 2090,
        "scenarioValue": 0.206600780578834
      },
      {
        "regionId": "0",
        "year": 2100,
        "scenarioValue": 0.196580200519227
      }
    ],
    "factor": {
      "id": "6",
      "unit": "kgCO2/2010$GDP",
      "unitShort": "tCO2/2010$GDP",
      "title": "Technology Factor"
    }
  }  
}